import React, { FC } from 'react';
import { View } from 'react-native';
import ShimmerPlaceholder from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';

import {
  DEFAULT_SHIMMER_DURATION,
  DEFAULT_SKELETON_BORDER_RADIUS,
  DEFAULT_SKELETON_HEIGHT,
  DEFAULT_SKELETON_WIDTH,
  SKELETON_PRESET_CONFIG,
} from './constants';
import type { SkeletonProps } from './types';

const Skeleton: FC<SkeletonProps> = ({ C, preset, width, height, borderRadius, shimmerColors, duration, style }) => {
  const presetConfig = preset ? SKELETON_PRESET_CONFIG[preset] : undefined;

  const resolvedWidth = width ?? presetConfig?.width ?? DEFAULT_SKELETON_WIDTH;
  const resolvedHeight = height ?? presetConfig?.height ?? DEFAULT_SKELETON_HEIGHT;
  const resolvedBorderRadius = borderRadius ?? DEFAULT_SKELETON_BORDER_RADIUS;
  const resolvedDuration = duration ?? DEFAULT_SHIMMER_DURATION;
  const resolvedColors = shimmerColors ?? [C('Gray/Light/3'), C('Gray/Light/2'), C('Gray/Light/3')];

  return (
    <View style={style}>
      <ShimmerPlaceholder
        LinearGradient={LinearGradient}
        style={{ width: resolvedWidth, height: resolvedHeight, borderRadius: resolvedBorderRadius }}
        shimmerColors={resolvedColors}
        visible={false}
        duration={resolvedDuration}
      />
    </View>
  );
};

export default Skeleton;
